(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function destroyFeaturedProducts(root) {
    if (!root || !root.wasuiProductsSwiper) return;

    root.wasuiProductsSwiper.destroy(true, true);
    root.wasuiProductsSwiper = null;
    delete root.dataset.wasuiProductsReady;
  }

  function initFeaturedProducts(root) {
    if (!root) return;

    if (mobileQuery.matches) {
      destroyFeaturedProducts(root);
      return;
    }

    if (root.dataset.wasuiProductsReady === 'true' || typeof Swiper === 'undefined') return;

    var swiperElement = root.querySelector('.wasui-featured-products__swiper');
    if (!swiperElement) return;

    root.dataset.wasuiProductsReady = 'true';

    root.wasuiProductsSwiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      grabCursor: true,
      speed: 500,
      breakpoints: {
        990: {
          freeMode: false
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wasui-product-slider]').forEach(initFeaturedProducts);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initFeaturedProducts(event.target.querySelector('[data-wasui-product-slider]'));
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', initAll);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(initAll);
  }
})();
